import React from 'react';
import { useTranslation } from 'react-i18next';

const SalesTopProducts = ({ data }) => {
    const { t } = useTranslation();
    if (!data?.products?.length) return null;

    const strings = t('salesAnalytics.topProductsWidget', { returnObjects: true });
    const products = data.products;
    const maxQty = Math.max(...products.map(p => parseFloat(p.total_quantity) || 0));

    return (
        <div style={cardStyle}>
            <div style={headerStyle}>
                <div>
                    <span style={titleStyle}>{strings.title}</span>
                    <div style={subtitleStyle}>{strings.subtitle}</div>
                </div>
                <span style={badgeStyle}>{strings.productsCount.replace('{count}', data.total_products ?? products.length)}</span>
            </div>
            <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                    <thead>
                        <tr style={{ borderBottom: '1px solid #f3f4f6' }}>
                            <th style={th('left')}>{strings.headers.product}</th>
                            <th style={th('left')}>{strings.headers.category}</th>
                            <th style={th('right')}>{strings.headers.orders}</th>
                            <th style={th('right')}>{strings.headers.quantity}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {products.map((row, i) => {
                            const qty = parseFloat(row.total_quantity) || 0;
                            const pct = maxQty > 0 ? (qty / maxQty) * 100 : 0;
                            return (
                                <tr key={row.product_size_id || i}
                                    style={{ borderBottom: '1px solid #f9fafb', transition: 'background 0.1s' }}
                                    onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f9fafb'}
                                    onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
                                >
                                    <td style={{ ...td, maxWidth: 180 }}>
                                        <div style={{ fontWeight: 600, color: '#111827', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                            {row.alias_name || row.product_name}
                                        </div>
                                        <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 1 }}>{row.product_name}</div>
                                    </td>
                                    <td style={td}>
                                        <span style={{ fontSize: 11, fontWeight: 600, color: '#7c3aed', backgroundColor: '#f5f3ff', borderRadius: 6, padding: '2px 8px', whiteSpace: 'nowrap' }}>
                                            {row.category_name}
                                        </span>
                                    </td>
                                    <td style={{ ...td, textAlign: 'right', fontWeight: 700, color: '#7c3aed' }}>{row.order_count}</td>
                                    <td style={{ ...td, textAlign: 'right' }}>
                                        <div style={{ fontWeight: 600, color: '#111827' }}>
                                            {Number(qty.toFixed(0)).toLocaleString('en-IN')}
                                        </div>
                                        <div style={{ height: 3, borderRadius: 2, backgroundColor: '#e5e7eb', marginTop: 4, minWidth: 60 }}>
                                            <div style={{ height: '100%', borderRadius: 2, backgroundColor: '#7c3aed', width: `${pct}%` }} />
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

const cardStyle = { backgroundColor: '#fff', borderRadius: 16, border: '1px solid #f3f4f6', boxShadow: '0 1px 4px rgba(0,0,0,0.06)', overflow: 'hidden', height: '100%' };
const headerStyle = { padding: '18px 20px 14px', borderBottom: '1px solid #f3f4f6', display: 'flex', justifyContent: 'space-between', alignItems: 'center' };
const titleStyle = { fontSize: 15, fontWeight: 700, color: '#111827', display: 'block' };
const subtitleStyle = { fontSize: 12, color: '#9ca3af', marginTop: 2 };
const badgeStyle = { fontSize: 11, fontWeight: 700, color: '#7c3aed', backgroundColor: '#f5f3ff', borderRadius: 20, padding: '3px 10px' };
const th = (align) => ({ padding: '10px 16px', textAlign: align, fontSize: 11, fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.5px', backgroundColor: '#fafafa', whiteSpace: 'nowrap' });
const td = { padding: '10px 16px', verticalAlign: 'middle' };

export default SalesTopProducts;
